import { Component, Input, Type } from '@angular/core';
import { EntityChangeLogMetaDataType } from 'enums/EntityChangeLogMetaDataType';
import { LogRequestModel } from 'models/generated/Logging.Api.Models.LogRequest';
import { Layout } from 'modules/layout';
import { ListView } from 'modules/list-view';
import { CustomDatePipe } from 'pipes/custom-date.pipe';
import { TranslatePipe } from 'pipes/translate.pipe';
import { UserPipe } from 'pipes/user.pipe';
import { LogEvent, LoggingService } from 'services/logging.service';
import { LogChangesComponent } from './log-changes.component';

export class SystemLogFilter {
	entityType: Type<Object>;
	logRequest: LogRequestModel;
	constructor(entityType: Type<Object>, logRequest: LogRequestModel) {
		this.entityType = entityType;
		this.logRequest = logRequest;
	}
}

@Component({
	selector: 'search-log',
	templateUrl: './search-log.component.html',
	imports: [Layout, ListView, LogChangesComponent, TranslatePipe, CustomDatePipe, UserPipe]
})
export class SearchLogComponent {

	logEntries?: LogEvent[];
	entityChangeLogMetaDataType = EntityChangeLogMetaDataType;

	@Input() set filteredEntities(filters: SystemLogFilter[]) {
		let logEntries: LogEvent[] = [];

		Promise.all(
			filters.map(filter => this.loggingService.getLogsForEntities(filter.entityType, filter.logRequest).then(logs => { logEntries = logEntries.concat(logs); }))
		).then(() => {
			this.logEntries = logEntries;
		});
	}

	constructor(private readonly loggingService: LoggingService) { }
	
	getChangedProperties(logEntry: LogEvent): string {

		if (!logEntry.previousValue) return 'Created';
		if (!logEntry.currentValue) return 'Deleted';

		const keysOld = Object.keys(logEntry.previousValue);
		const keysNew = Object.keys(logEntry.currentValue);
		const keys = [...new Set(keysOld.concat(keysNew))];
		const changedKeys: string[] = [];

		for (const key of keys) {
			if (logEntry.previousValue[key] !== logEntry.currentValue[key]) changedKeys.push(key);
		}

		return changedKeys.join(', ');
	}
}
